<mat-card class="size flex-around-center " style="display: flex;flex-flow: column;">
  <div class="flex-around-center flex-direction-column w100">
    <div class="w100 flex-center-center flex-direction-row">
      <div class="flex-center-center flex-direction-row container-icon-size" style="height: 40px;">
        @for (icon of icons; track icon) {
          <button mat-icon-button [color]="color(icon.isSet)" class="no-cursor" disableRipple>
            @if (icon.icon!=null) {
              <mat-icon>{{icon.icon}}</mat-icon>
            } @else {
              <mat-icon [svgIcon]="icon.svgIcon!" [color]="color(icon.isSet)"></mat-icon>
            }
          </button>
        }

        <!--                <button mat-icon-button [color]="color(IS_ACS_ON)" class="no-cursor" disableRipple>-->
        <!--                    <mat-icon>hot_tub</mat-icon>-->
      <!--                </button>-->
      <!--                <button mat-icon-button [color]="color(IS_ECO_MODE)" class="no-cursor" disableRipple>-->
      <!--                    <mat-icon svgIcon="ecology"></mat-icon>-->
    <!--                </button>-->
  </div>
  <div class="flex-center-center" style="height: 40px;" (click)="openSettings()">
    <button mat-icon-button>
      <mat-icon>settings</mat-icon>
    </button>
  </div>
</div>
<mat-card
  matRipple
  [matRippleCentered]="true"
  [matRippleRadius]="90"
  (click)="openTemperature()"
  class="size-card-settingValue background-color-purple-gradient-circle flex-direction-column cursor"
  style="display: flex;justify-content: center;align-items: center">
  @if (settingTemperature) {
    <h1 style="margin: 0 0 -5px 0;color: white;font-size: xx-large">{{settingTemperature}}<sup
    style="font-size: x-small">°C</sup></h1>
    @if (currentTemperature) {
      <h3 style="color: white;margin: 0">{{currentTemperature}}<sup
      style="font-size: xx-small">°C</sup></h3>
    }
  } @else {
    @if (currentTemperature) {
      <h1 style="color: white;font-size: xx-large;margin: 0"
        >{{currentTemperature}}
        <sup
        style="font-size: xx-small">°C</sup></h1>
      }
    }
  </mat-card>
  @if (loadValue) {
    <mat-spinner diameter="40" style="position: absolute;"
    ></mat-spinner>
  }
  @if (title) {
    <h2 style="margin: 0;max-height: 64px;overflow: auto">
      {{title}}
    </h2>
  }
</div>
<div class="width-currentValue flex-between-center flex-direction-row w100">
  <div class="size-card-currentValue text-color-primary">
    <div class="size-card-currentValue  flex-around-center flex-direction-row w100">
      <ng-content select="[button]">
      </ng-content>
    </div>
  </div>
</div>
</mat-card>
